<template>
  <div :class="[baseCss, 'select-none']" v-if="items.length">
    <div :is="vertical ? 'div' : 'table-layout'" :class="[`${baseCss}-container`]" equal-cells>
      <div :is="vertical ? 'div' : 'row'" :class="[`${baseCss}-container-inner-wrapper`]">
        <div @click="$emit('step-click', {item, index})" :is="vertical ? 'div' : 'cell'" v-for="(item, index) in items" :class="[`${baseCss}-single-step`, stepClickable ? 'cursor-pointer' : null, 'transition-all', 'duration-250', index <= currentStep  ? null : ['grayscale', 'disabled', 'pointer-events-none']]" :key="index">
          <table-layout y-align="middle">
            <row>
              <cell :style="{width: markerSize}">
                <avatar :font-size="dense ? 'sm' : 'base'" :icon-provider="iconProvider" :color="markerColor" :color-lightness="markerColorLightness" :bg-color="error === index && currentStep === index ? errorColor : color" :bg-color-lightness="error === index && currentStep === index ? errorColorLightness : colorLightness" :icon="error === index && currentStep === index ? iconStepError : index <= currentStep ? iconStepFinished : null" :icon-size="dense ? 1 : 1.2" :class="['transition-all', 'duration-250', `${baseCss}-marker`]" :text="index <= currentStep ? null : (index + 1).toString()" :size="markerSize" />
              </cell>
              <cell :class="['pl-1', error === index && currentStep === index ? setTextColor('errorColor', 'errorColorLightness') : setTextColor(), dense ? ['text-sm'] : ['text-base', 'font-semibold']]">
                <div v-html="item.title" :class="['truncate', `${baseCss}-title`]" />
              </cell>
              <cell :class="['px-2']" full-width>
                <line-ripple :height="dense ? '1px' : '2px'" :visible="index <= currentStep" :ripple-bg-color="error === index && currentStep === index ? errorColor : color" :ripple-bg-color-lightness="error === index && currentStep === index ? errorColorLightness : colorLightness" />
              </cell>
            </row>
          </table-layout>
          <table-layout>
            <row>
              <cell :style="{width: markerSize}" />
              <cell :class="['p-1', dense ? 'text-xs' : 'text-sm', error === index && currentStep === index ? setTextColor('errorColor', 'errorColorLightness') : null]" v-html="item.text" />
            </row>
          </table-layout>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'Steps',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('steps', [])
    }
  },
  computed: {
    markerSize () {
      return this.dense ? '26px' : '32px'
    }
  },
  props: {
    vertical: {
      type: Boolean
    },
    items: {
      type: Array,
      default () {
        return []
      }
    },
    dense: {
      type: Boolean
    },
    color: {
      type: String
    },
    colorLightness: {
      type: Number
    },
    currentStep: {
      type: Number,
      default: 0
    },
    markerColor: {
      type: String
    },
    markerColorLightness: {
      type: Number
    },
    iconStepFinished: {
      type: String,
      default: 'check-all'
    },
    iconStepError: {
      type: String,
      default: 'alert-outline'
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    stepClickable: {
      type: Boolean
    },
    error: {
      type: Number
    },
    errorColor: {
      type: String,
      default: 'red'
    },
    errorColorLightness: {
      type: Number,
      default: 500
    }
  }
}
</script>
<style>
.bcq-steps .bcq-steps-marker .bcq-icon
{
  margin-top: -3px;
}

.bcq-ui-theme-dark .bcq-steps .bcq-steps-single-step.grayscale .bcq-steps-title
{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/steps/steps.vue